<template>
  <div>
    
    <v-row>
      <v-col cols="6">
        <snapshot-editor :snapshot="activeSnapshot" @on-generate="onGenerate" :eventData="eventData"></snapshot-editor>
      </v-col>
      <v-col cols="6">
        <snapshots @on-snapshot-selected="onSnapshotSelected" ref="snapshots"></snapshots>
      </v-col>
    </v-row>

    <v-btn @click="loadAPI" x-large color="primary">
      {{ activeSnapshot ? activeSnapshot.id : 'NULL' }} LOAD
    </v-btn>

    <v-row class="align-center border-b--thin pa-2">

      <v-spacer></v-spacer>

      <div>
        <transition
        name="fade-transition"
        mode="out-in">
          <v-layout v-if="isLoading" key="L1" class="mr-2" align-baseline>
            <span class="grey--text caption">LOADING...</span>&nbsp;
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-layout>
          <div v-else key="L2"></div>
        </transition>
      </div>

      <v-btn text outlined class="mr-2" color="green" text-color="white">
        <json-excel
        :fetch="fetchData">
          <v-icon small color="green" class="mr-2">mdi-file-excel</v-icon>
          Download excel
        </json-excel>
      </v-btn>
    </v-row>
    

    <!-- TABLE -->
    <table class="final-table th-no-padding lines-b pointer hover full-width">
      <colgroup ref="colgroup1">
        <col width="30px">
        <col width="15px">
        <col width="10px">
        <col width="10px">
        <col width="10px">
        <col width="10px">
      </colgroup>

      <tr class="unselectable">
        <c-table-header
        title="Name"
        code="name"
        class="sticky"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="A_ID"
        code="archive_id"
        class="sticky"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>
      
        <c-table-header
        title="Quantity"
        code="quantity"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Price Per Unit"
        code="price_per_unit"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Value"
        code="value"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Timelines"
        code="timelines"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>
      </tr>

      <tr>
        <td class="sticky">
          <v-text-field
          v-model="filters.search.name"
          placeholder="Search"
          hide-details
          clearable
          class="crx-box-input"
          solo></v-text-field>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>

      <row
      v-for="item in items" 
      :key="item.id"
      :item="item"
      :searchFilters="filters.search"
      ></row>

    </table>

    <!-- PAGINATION -->
    <v-layout align-center justify-center class="pa-2">

      <v-btn
      text
      :disabled="page <= 0"
      @click="goToFirstPage()"
      class="mr-2"
      >
        1
      </v-btn>

      <v-btn
      text
      :disabled="page <= 0"
      @click="goToPreviousPage()"
      class="mr-2"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <template v-if="pagination.rowCount > 0">
        <span class="font-weight-bold">
          {{ page + 1 }}
        </span>
      </template>
      <template v-else>
        1
      </template>

      <v-btn
      :disabled="page >= pagination.pages - 1"
      text
      @click="goToNextPage()"
      class="ml-2 mr-2"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>

      <v-btn
      text
      :disabled="!(page < (pagination.pages - 1))"
      @click="goToLastPage()"
      class="mr-2"
      >
        {{ pagination.pages || 1 }}
      </v-btn>

      <v-spacer></v-spacer>

      |

      <c-s-list-items-per-page :rowsPerPage.sync="filters.rowsPerPage" class="mr-2"></c-s-list-items-per-page>

    </v-layout>
    
        
  </div>
</template>

<script>
import JsonExcel from 'vue-json-excel'
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListBindings'
import Row from './row'
import Snapshots from './snapshots/card'
import SnapshotEditor from './snapshots/editor'

export default {
  components: {
    Row,
    JsonExcel,
    Snapshots,
    SnapshotEditor
  },
  mixins: [ServerListController, ServerListBindings],
  data () {
    return {
      eventSource: null,
      activeSnapshot: null,
      page: 0,
      filters: {
        rowsPerPage: 10,
        sortCol: 'name',
        sortAscending: true,
        date: {
          // mainSelect: 'is equal to',
          // isInTheLast_select: 'days',
          date1: null
        },
        search: {
          id: '',
          name: ''
        },
        categories: [],
        priceLists: []
      },
      eventData: {
        current: 0,
        total: 0
      },
      isLoading: false
    }
  },
  watch: {
    'filters.date.date1': {
      // deep: true,
      handler (nv) {
        // this.loadAPI()
      }
    }
  },
  methods: {
    onSnapshotSelected (snapshot) {
      this.activeSnapshot = snapshot
      this.loadAPI()
    },
    onGenerate () {
      this.$refs.snapshots.loadAPI()
      this.loadAPI()
    },
    async startEventListener () {
      var bearerToken = localStorage.getItem('token')
      console.log(bearerToken)
      if (!this.eventSource || true) {
        try {
          this.eventSource = new EventSource(`${this.$axios.defaults.baseURL}accounting/subscribe-historical-stock`, 
          {});
        } catch (e) {
          console.log(e)
        }
        this.eventSource.onmessage = (event) => {
          console.log(event)
          const parsedData = JSON.parse(event.data);
          this.eventData.current = parsedData.current + 1
          this.eventData.total = parsedData.total
        };
      }
    },
    async fetchData(){
      var data = JSON.parse(JSON.stringify(this.filters))
      data.page = 'all'
      data.snapshot_id = this.activeSnapshot.id
      var response = await this.$axios.post(`/accounting/historical-stock`, data)
      var rows = response.data.rows
      var new_rows = rows.map(item => {
        
        var quantity = item.quantity
        var unit_of_measure = 'units'
        if (item.definition.metric === 0) {
          unit_of_measure = 'units'
        }
        if (item.definition.metric === 1) {
          quantity = quantity / 1000 // convert to L
          unit_of_measure = 'litre'
        }
        if (item.definition.metric === 2) {
          quantity = quantity / 1000 / 1000 // convert to KGs
          unit_of_measure = 'kg'
        }
        if (item.definition.metric === 3) {
          quantity = quantity / 1000 // convert to M
          unit_of_measure = 'metre'
        }
        if (quantity < 0.0001) {
          quantity = 0.0001
        }

        // value = Number(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
        // var price = Number(priceStruct.price).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})      

        return {
          inventory_item_id: item.definition.id,
          name: item.definition.name,
          AID: item.archive_id,
          quantity: quantity,
          unit_of_measure: unit_of_measure,
          price_per_unit: item.price_per_unit,
          value: item.value
        }

        /* var hmetric = this.$crx.metrics.humanizeDBMetric(item.quantity, item.definition.metric)
        item.quantity = hmetric.quantity
        console.log(hmetric) */
      })
      console.log(new_rows)

      var totalValue = new_rows.reduce((a, i) => a + i.value, 0)
      new_rows.push({
        inventory_item_id: null,
        name: null,
        AID: null,
        quantity: null,
        unit_of_measure: null,
        price_per_unit: null,
        value: totalValue
      })

      return new_rows
    },
    loadAPI: _.debounce(function (e) {
      if (!this.activeSnapshot) {
        return
      }
      this.isLoading = true
      var data = JSON.parse(JSON.stringify(this.filters))
      data.page = this.page
      data.snapshot_id = this.activeSnapshot.id
      this.$axios.post(`/accounting/historical-stock`, data)
        .then(_response => {
        console.log('reached 1')
        /* var rows = _response.data.rows
        var new_rows = rows.map(item => {
          var priceStruct = {
            quantity: 0,
            price: 0
          }
          
          for (var pricelist of item.priceLists) {
            var json_data = JSON.parse(pricelist.json_data)
            if (json_data['47']) {
              priceStruct = json_data['47'][0]
            }
          }
          

          var value = 0
          if (item.definition.metric === 0) {
            value = item.quantity * priceStruct.price
          } else {
            value = (item.quantity / priceStruct.quantity) * priceStruct.price
          }  

          item.value = Number(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
          item.price = Number(priceStruct.price).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})

          return item
        })
        this.items = new_rows
        console.log('done')
        console.log(this.items) */

        var rows = _response.data.rows
        this.pagination.rowCount = _response.data.count
        this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
        if (this.items.length > rows.length) {
          this.currentIndex = 0
        }
        this.items = rows

      })
        .catch(error => {
        console.log(error)
        this.$root.$errorSnackbar(error)
      })
        .then(() => {
        this.isLoading = false
      })
    }, 150, {leading: true}),
  },
  created () {
    this.loadAPI()
    this.startEventListener()
  },
  beforeUnmount () {
    this.eventSource.close()
  }
}
</script>